import React from 'react';
import classNames from 'classnames';
import {View} from 'MWC';
import {CSSTransition} from 'react-transition-group';
import '../less/hoverItem.less';
import {HEADER_HOVER_TIMEOUT} from '../constants';

class HoverItem extends View {
    constructor(props) {
        super(props);

        this.leaveTimeout = null;

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    componentWillUnmount() {
        if (this.leaveTimeout) clearTimeout(this.leaveTimeout);
    }

    handleMouseEnter() {
        if (this.leaveTimeout) {
            clearTimeout(this.leaveTimeout);
            this.leaveTimeout = null;
        }

        this.leaveTimeout = setTimeout(() => {
            this.props.toggleHover(true, this.props.alias);
            this.leaveTimeout = null;
        }, HEADER_HOVER_TIMEOUT);
    }

    handleMouseLeave() {
        if (this.leaveTimeout) {
            clearTimeout(this.leaveTimeout);
            this.leaveTimeout = null;
        }

        this.leaveTimeout = setTimeout(() => {
            this.props.toggleHover(false, this.props.alias);
            this.leaveTimeout = null;
        }, HEADER_HOVER_TIMEOUT);
    }

    render() {
        const {children = [], active, alias, hover, className: extraClass} = this.props;

        const mainItem = children.find(c => c && c.props && c.props.top);
        const subItems = children.filter(c => c && c.props && !c.props.top);

        const className = classNames('module-header-menu-item', extraClass, {
            active: active === alias
        });

        return (
            <div
                className={className}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                ref={this.menuRef}
            >
                <span>{mainItem}</span>

                <CSSTransition
                    in={hover}
                    timeout={HEADER_HOVER_TIMEOUT}
                    classNames='fly-desktop-header-toggle'
                    unmountOnExit
                >
                    <div className={`toggle-items-wrapper ${alias}`}>
                        <div className='toggle-items'>{subItems}</div>
                    </div>
                </CSSTransition>
            </div>
        );
    }
}

export default HoverItem;
